module.exports = require("@swa-ui/placements/src/SystemMessage/SystemMessage.module.scss");